import { startTimeout } from './timeout';

export interface PingPongLoopConfig {
  abortSignal: AbortSignal;
  /** ping을 보내고 pong을 받기까지 최대 얼마나 기다릴 것인지 */
  timeoutMs: number;
  /** pong을 받고 얼마 뒤에 다시 ping을 보낼 것인지 */
  waitMs: number;
  ping(): void;
  timeout(): void;
}

export interface PingPongLoop {
  pong(): void;
  clearTimeout(): void;
}

export function startPingPongLoop(config: PingPongLoopConfig) {
  const pingTimeout = startTimeout(config.timeout, config.timeoutMs);
  const waitAndPing = startTimeout(ping, config.waitMs);

  config.abortSignal.addEventListener('abort', () => {
    pingTimeout.clear();
    waitAndPing.clear();
  });

  ping();
  function ping() {
    pingTimeout.reset();
    config.ping();
  }

  return {
    pong() {
      if (config.abortSignal.aborted) return;
      pingTimeout.clear();
      waitAndPing.reset();
    },
    clearTimeout: pingTimeout.clear,
  };
}
